import i18next from 'i18next';
import type { UseTranslationResponse } from 'react-i18next';
import { useTranslation } from 'react-i18next';

export const ns = 'shared';
export const keyPrefix = 'navbar_panel';
export const useNavbarPanelTranslation = (): UseTranslationResponse<
  typeof ns,
  typeof keyPrefix
> => useTranslation(ns);
export const navbarPanelTranslation = (key: string) => i18next.t(`${ns}:${keyPrefix}.${key}`);

export const ruRu = ({
  [keyPrefix]: {
    theme_light: 'Светлая тема',
    theme_dark: 'Тёмная тема',
    language_ru: 'Русский',
    language_en: 'Английский',
    language_esEs: 'Испанский',
    language_ptBr: 'Португальский (Бразилия)',
  },
}) as Record<string, unknown>;

export const en = ({
  [keyPrefix]: {
    theme_light: 'Light theme',
    theme_dark: 'Dark theme',
    language_ru: 'Russian',
    language_en: 'English',
    language_esEs: 'Spanish',
    language_ptBr: 'Portuguese (Brazil)',
  },
}) as Record<string, unknown>;

export const esEs = ({
  [keyPrefix]: {
    theme_light: 'Tema claro',
    theme_dark: 'Tema oscuro',
    language_ru: 'Ruso',
    language_en: 'Inglés',
    language_esEs: 'Español',
    language_ptBr: 'Portugués (Brasil)',
  },
}) as Record<string, unknown>;

export const ptBr = ({
  [keyPrefix]: {
    theme_light: 'Tema claro',
    theme_dark: 'Tema escuro',
    language_ru: 'Russo',
    language_en: 'Inglês',
    language_esEs: 'Espanhol',
    language_ptBr: 'Português (Brasil)',
  },
}) as Record<string, unknown>;
